import type { StoredElement, ElementsStorage } from "@app-types/element.types";

/**
 * Check if value is a valid binary flag ("0" or "1")
 */
function isBinaryFlag(value: unknown): value is "0" | "1" {
  return value === "0" || value === "1";
}

/**
 * Type guard for StoredElement
 */
export function isStoredElement(data: unknown): data is StoredElement {
  if (typeof data !== "object" || data === null) return false;

  const obj = data as Record<string, unknown>;

  return (
    typeof obj.element_id === "string" &&
    isBinaryFlag(obj.is_hd) &&
    isBinaryFlag(obj.is_animated) &&
    typeof obj.frames === "string" &&
    typeof obj.group_name === "string" &&
    typeof obj.category === "string"
  );
}

/**
 * Type guard for ElementsStorage
 */
export function isElementsStorage(data: unknown): data is ElementsStorage {
  if (typeof data !== "object" || data === null) return false;

  return Object.values(data as Record<string, unknown>).every(isStoredElement);
}
